import React from 'react';
import './PieDePaso.css';

/**
 * Pie de un paso plegable: el botón que lo cierra y abre el siguiente.
 *
 * Es lo que convierte un acordeón en un recorrido. Sin él, un acordeón es solo
 * una lista de cajas plegadas: no queda claro que hay un orden, ni cuándo
 * terminaste con una parte, ni que la de abajo es la que sigue. La única forma
 * de avanzar es descubrir que los títulos son clickeables.
 *
 * Vive acá y no adentro de EditableServiceCard —que es donde nació— porque el
 * detalle de servicio no es el único formulario armado con PasoPlegable: los
 * datos básicos del negocio son el mismo acordeón y necesitan el mismo botón.
 * Escribirlo dos veces es cómo terminan siendo dos botones distintos.
 *
 * Va con `btn-primary` (la píldora de la marca, global en index.css) y no con
 * el <Button> de shadcn para que sea exactamente el mismo botón que el resto
 * del onboarding, que es de donde uno viene al llegar acá.
 */
export default function PieDePaso({
  texto = 'Continuar',
  onClick,
  // Mismos nombres que PasoNavegador: si no se puede avanzar, el botón queda
  // apagado y el motivo se cuenta en el title. Un botón apagado sin explicación
  // es indistinguible de uno roto.
  puedeAvanzar = true,
  motivoBloqueo = '',
}) {
  return (
    <div className="parte-pie">
      <button
        type="button"
        className="btn-primary"
        onClick={onClick}
        disabled={!puedeAvanzar}
        title={!puedeAvanzar ? motivoBloqueo : undefined}
      >
        {texto}
      </button>
    </div>
  );
}
